exports.modelo5 = {
  id: '9dee1d6d-73bb-4caf-875a-c8a88d572f5d',
  domain: null,
  trigger: '',
  is_trigger: 0,
  name: 'Sem nome',
  status: 'true',
  chamadaInicial: 'Está com duvidas?',
  Email: 'undefined\n',
  design: {
    avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Leopoldo.png',
    color: '#000000',
    timeOpen: 7,
    side: 1,
    title: 'Chat Booster - Name',
    subTitle: 'Atendente Online',
  },
  inicial: {
    callToAction: 'Sim eu tenho interesse',
    mensagens: [
      {
        sequencia: 2,
        message: 'Seja bem vindo ao nosso atendimento?',
      },
      {
        sequencia: 1,
        message: 'Olá, tudo bem?',
      },
    ],
  },
  fluxo: [
    {
      message: '',
      sequencia: 3,
      type: 1,
      id_type: 1,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'name',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 1,
      idField: 'name',
      typeField: 'string',
      phField: 'Seu nome por favor',
      autocomplete: 'true',
    },
    {
      message: 'Qual seu nome?',
      sequencia: 2,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Para isso preciso de algumas informações rápidas',
      sequencia: 1,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Prazer {{name}}',
      sequencia: 4,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Em qual e-mail gostaria de receber as informações?',
      sequencia: 5,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 6,
      type: 1,
      id_type: 3,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'email',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 3,
      idField: 'email',
      typeField: 'email',
      phField: 'Seu Email por favor',
      autocomplete: 'true',
    },
    {
      message: 'Poderia me informar seu whatsapp? (Prometo não incomodar????)',
      sequencia: 7,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 8,
      type: 1,
      id_type: 2,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Telefone',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 2,
      idField: 'phone',
      typeField: 'phone',
      phField: 'Seu whatsApp por favor',
      autocomplete: 'true',
    },
    {
      message: 'Legal, estamos quase lá...',
      sequencia: 9,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'De qual empresa você fala?',
      sequencia: 10,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 11,
      type: 1,
      id_type: 5,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'empresa',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 5,
      idField: 'Texto',
      typeField: 'string',
      phField: 'Escreva um texto',
      autocomplete: 'false',
    },
    {
      message: 'Por último, qual a sua duvida?',
      sequencia: 12,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 13,
      type: 1,
      id_type: 5,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Duvida',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 5,
      idField: 'Texto',
      typeField: 'string',
      phField: 'Escreva um texto',
      autocomplete: 'false',
    },
    {
      message: 'Obrigado {{name}}! Em breve nossa equipe de consultores irá entrar em contato para te apresentar a melhor solução para você.',
      sequencia: 14,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
  ],
  smartTitle: [
    {
      scTitle: 'Escreva aqui sua chamada inteligente',
      status: 1,
      time: 30,
      id: '1',
      dataId: '1',
    },
  ],
}
exports.modelo1 = {
  id: '9dee1d6d-73bb-4caf-875a-c8a88d572f5d',
  domain: null,
  trigger: '',
  is_trigger: 0,
  name: 'Sem nome',
  status: 'true',
  chamadaInicial: 'Quer saber como aumentar suas vendas com marketing digital?',
  Email: 'undefined\n',
  design: {
    avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Leopoldo.png',
    color: '#000000',
    timeOpen: 7,
    side: 1,
    title: 'Chat Booster - Name',
    subTitle: 'Atendente Online',
  },
  inicial: {
    callToAction: 'Sim eu tenho interesse',
    mensagens: [
      {
        sequencia: 2,
        message: 'Quer saber como podemos aumentar suas vendas com marketing digital?',
      },
      {
        sequencia: 1,
        message: 'Olá, tudo bem?',
      },
    ],
  },
  fluxo: [
    {
      message: '',
      sequencia: 3,
      type: 1,
      id_type: 1,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'name',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 1,
      idField: 'name',
      typeField: 'string',
      phField: 'Seu nome por favor',
      autocomplete: 'true',
    },
    {
      message: 'Qual seu nome?',
      sequencia: 2,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Prazer {{name}}',
      sequencia: 4,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Para isso preciso de algumas informações rápidas',
      sequencia: 1,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Em qual e-mail gostaria de receber as informações?',
      sequencia: 5,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 6,
      type: 1,
      id_type: 3,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'email',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 3,
      idField: 'email',
      typeField: 'email',
      phField: 'Seu Email por favor',
      autocomplete: 'true',
    },
    {
      message: 'Informe seu Whatsapp.',
      sequencia: 7,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 8,
      type: 1,
      id_type: 2,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Telefone',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 2,
      idField: 'phone',
      typeField: 'phone',
      phField: 'Seu whatsApp por favor',
      autocomplete: 'true',
    },
    {
      message: 'Legal, estamos quase lá...',
      sequencia: 9,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Informe o nome da empresa',
      sequencia: 10,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 11,
      type: 1,
      id_type: 5,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Empresa',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 5,
      idField: 'Texto',
      typeField: 'string',
      phField: 'Escreva um texto',
      autocomplete: 'false',
    },
    {
      message: 'Por último, informe a quantidade de colaboradores.',
      sequencia: 12,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 13,
      type: 2,
      id_type: 0,
      label: 'Colaboradores',
      options: '[{"name":"1 a 50","whatsApp":""},{"name":"50 a 100","whatsApp":""},{"name":"Mais de 100","whatsApp":""}]',
      id: null,
      idField: null,
      tags: 'Opçao 1,Opçao 2,Opçao 3',
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Obrigado {{name}}! Em breve nossa equipe de consultores irá entrar em contato para lhe apresentar a melhor solução.',
      sequencia: 14,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
  ],
  smartTitle: [
    {
      scTitle: 'Escreva aqui sua chamada inteligente',
      status: 1,
      time: 30,
      id: '1',
      dataId: '1',
    },
  ],
}

exports.modelo2 = {
  id: '7a85728c-174e-4d12-9ad4-7cfe15c47cdd',
  domain: '',
  trigger: '',
  is_trigger: 0,
  name: 'Sem nome',
  status: 'true',
  chamadaInicial: 'Gostaria de se informar dos melhores serviços de tecnologia?',
  Email: '',
  design: {
    avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Kim.png',
    color: '#000000',
    timeOpen: 7,
    side: 1,
    title: 'Chat Booster - Name',
    subTitle: 'Atendente Online',
  },
  inicial: {
    callToAction: 'Sim eu tenho interesse',
    mensagens: [
      {
        sequencia: 1,
        message: 'Olá, tudo bem?',
      },
      {
        sequencia: 2,
        message: 'Quer consultar o melhor preço para o serviço que está buscando?',
      },
    ],
  },
  fluxo: [
    {
      message: 'Para isso preciso de algumas informações rápidas',
      sequencia: 1,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Qual seu nome?',
      sequencia: 2,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 3,
      type: 1,
      id_type: 1,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'name',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 1,
      idField: 'name',
      typeField: 'string',
      phField: 'Seu nome por favor',
      autocomplete: 'true',
    },
    {
      message: 'Prazer {{name}}',
      sequencia: 4,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },


    {
      message: 'Em qual e-mail gostaria de receber as informações?',
      sequencia: 5,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 6,
      type: 1,
      id_type: 3,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'email',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 3,
      idField: 'email',
      typeField: 'email',
      phField: 'Seu Email por favor',
      autocomplete: 'true',
    },
    {
      message: 'Informe seu Whatsapp.',
      sequencia: 7,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 8,
      type: 1,
      id_type: 2,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Telefone',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 2,
      idField: 'phone',
      typeField: 'phone',
      phField: 'Seu whatsApp por favor',
      autocomplete: 'true',
    },
    {
      message: 'Legal, estamos quase lá...',
      sequencia: 9,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Qual serviço você necessita de orçamento?',
      sequencia: 10,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Especifique onde será instalado (empresa, residência ou condomínio)',
      sequencia: 10,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 11,
      type: 2,
      id_type: 0,
      label: 'Lugares',
      options: '[{"name":"Empresa","whatsApp":""},{"name":"residência","whatsApp":""},{"name":"condomínio","whatsApp":""}]',
      id: null,
      idField: null,
      tags: 'Opçao 1,Opçao 2,Opçao 3',
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Descreva de maneira breve o serviço que está buscando',
      sequencia: 12,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 13,
      type: 1,
      id_type: 5,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'texto',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 5,
      idField: 'Texto',
      typeField: 'string',
      phField: 'Escreva um texto',
      autocomplete: 'false',
    },
    {
      message: 'Obrigado! Em breve nossa equipe de consultores irá entrar em contato para lhe apresentar o serviço requerido.',
      sequencia: 14,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },



  ],
  smartTitle: [
    {
      scTitle: 'Escreva aqui sua chamada inteligente',
      status: 1,
      time: 30,
      id: '1',
      dataId: '1',
    },
  ],
}

exports.modelo3 = {
  id: 'b3967a0e938dc2a6340e258630febd5a',
  domain: null,
  trigger: 'null',
  is_trigger: 0,
  name: 'Sem nome',
  status: 'true',
  chamadaInicial: 'Quer saber mais sobre Contabilidade?',
  Email: 'null',
  design: {
    avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Bruna.png',
    color: '#000000',
    timeOpen: 7,
    side: 0,
    title: 'Vsl Booster - Name',
    subTitle: 'Atendente Online',
  },
  inicial: {
    callToAction: 'Sim, quero saber. ',
    mensagens: [
      {
        sequencia: 1,
        message: 'Olá! ⭐ Você já imaginou como seria ter todas as suas questões contábeis resolvidas sem dor de cabeça? Estou aqui para te ajudar com isso!',
      },
    ],
  },
  fluxo: [
    {
      message: 'Que bom ouvir isso! Antes de tudo, me conta, como posso te chamar?😃',
      sequencia: 1,
      type: 0,
      id_type: null,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'null',
      sequencia: 2,
      type: 1,
      id_type: 1,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'name',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 1,
      idField: 'name',
      typeField: 'string',
      phField: 'Seu nome por favor',
      autocomplete: 'true',
    },
    {
      message: 'Prazer em te conhecer, {{nome}}! Sou um assistente virtual aqui para te guiar pelo mundo da contabilidade. Para te oferecer a melhor assistência, poderia me informar o melhor número de WhatsApp para mantermos contato?',
      sequencia: 3,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'null',
      sequencia: 4,
      type: 1,
      id_type: 2,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Telefone',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 2,
      idField: 'phone',
      typeField: 'phone',
      phField: 'Seu whatsApp por favor',
      autocomplete: 'true',
    },
    {
      message: 'Perfeito, {{nome}}! Agora, me conta um pouco mais sobre o que você precisa. Seja uma dúvida específica, serviços de contabilidade ou dicas para o seu negócio, estou aqui para ajudar.📚🧰',
      sequencia: 5,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 6,
      type: 1,
      id_type: 5,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Duvida',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 5,
      idField: 'Texto',
      typeField: 'string',
      phField: 'Escreva um texto',
      autocomplete: 'false',
    },
    {
      message: ' Obrigado por compartilhar isso comigo, {{nome}}! Sua dúvida é muito importante. Em breve, um de nossos consultores especializados entrará em contato pelo WhatsApp para oferecer a melhor solução para você. Enquanto isso, sinta-se à vontade para perguntar qualquer coisa ou explorar mais sobre nossos serviços!',
      sequencia: 7,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
  ],
  smartTitle: [
    {
      scTitle: 'Especialista VSL Booster',
      status: 1,
      time: 31,
      id: '1',
      dataId: '1',
    },
  ],
}

exports.modelo4 = {
  id: 'b3967a0e938dc2a6340e258630febd5a',
  domain: null,
  trigger: 'null',
  is_trigger: 0,
  name: 'Sem nome',
  status: 'true',
  chamadaInicial: 'Gostaria de se consultar com um advogado online?',
  Email: 'null',
  design: {
    avatar: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Braga.png',
    color: '#000000',
    timeOpen: 7,
    side: 0,
    title: 'Vsl Booster - Name',
    subTitle: 'Atendente Online',
  },
  inicial: {
    callToAction: 'Sim, vamos la',
    mensagens: [
      {
        sequencia: 1,
        message: 'Olá, tudo bem?',
      },
      {
        sequencia: 2,
        message: 'Quer falar agora com um advogado online?',
      },
    ],
  },
  fluxo: [
    {
      message: 'Para isso preciso de algumas informações rápidas ',
      sequencia: 1,
      type: 0,
      id_type: null,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Qual é o seu nome?',
      sequencia: 2,
      type: 0,
      id_type: null,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'null',
      sequencia: 3,
      type: 1,
      id_type: 1,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'name',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 1,
      idField: 'name',
      typeField: 'string',
      phField: 'Seu nome por favor',
      autocomplete: 'true',
    },
    {
      message: 'Prazer {{name}}',
      sequencia: 4,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Informe seu Whatsapp.',
      sequencia: 5,
      type: 0,
      id_type: null,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'null',
      sequencia: 6,
      type: 1,
      id_type: 2,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Telefone',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 2,
      idField: 'phone',
      typeField: 'phone',
      phField: 'Seu whatsApp por favor',
      autocomplete: 'true',
    },
    {
      message: 'Descreva seu problema ou dúvida.',
      sequencia: 7,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 8,
      type: 1,
      id_type: 5,
      options: null,
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      label: 'Duvida',
      obrigatorio: 0,
      type_ext: 'Texto',
      id: 5,
      idField: 'Texto',
      typeField: 'string',
      phField: 'Escreva um texto',
      autocomplete: 'false',
    },
    {
      message: 'Por último, você já tem advogado cuidando do seu caso?',
      sequencia: 9,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: '',
      sequencia: 10,
      type: 2,
      id_type: 0,
      options: '[{"name":"Sim","whatsApp":""},{"name":"Não","whatsApp":""}]',
      id_ext: '68b1f874-52c1-401b-9da5-a4504f284326',
      tags: 'Opçao 1,Opçao 2,Opçao 3',
      label: 'Responda',
      obrigatorio: 0,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
    {
      message: 'Obrigado! Em breve nossa equipe de advogados irá entrar em contato para apresentar a melhor opção para seu caso.',
      sequencia: 11,
      type: 0,
      id_type: 0,
      options: null,
      id: null,
      idField: null,
      typeField: null,
      phField: null,
      autocomplete: null,
    },
  ],
  smartTitle: [
    {
      scTitle: 'Especialista VSL Booster',
      status: 1,
      time: 31,
      id: '1',
      dataId: '1',
    },
  ],
}
